import {Component} from '@angular/core';
import {TabsPageContainer} from '../../../uiComponents/tabsPageContainer';

// CC: taken from email-flow-tabs.component.ts -> EmailFlowTabsComponent
@Component({
	selector: 'user-permissions-tabs',
	templateUrl: './user-permissions-tabs.component.html',
})
export class UserPermissionsTabsComponent extends TabsPageContainer {
	tabWidth = 160;
}
